// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__14tJd","notes":"Notes_notes__25Q9B","note":"Notes_note__1lSSR","markdown":"Notes_markdown__2oVUw"};